<div class="message-list-container" #scrollContainer (scroll)="onScroll()" data-testid="message-list-container">
	<div class="message-list" role="log" aria-label="Chat messages">
		@for (msg of messages; track msg.id; let i = $index) {
			<app-message
				[message]="msg"
				[userQuery]="getUserQuery(i)"
				[showLabel]="shouldShowLabel(i)"
				[isSidecar]="isSidecar"
				(openArtifact)="openArtifact.emit($event)"
				(viewDocument)="viewDocument.emit($event)"
				(requestFullscreen)="requestFullscreen.emit($event)"
			>
			</app-message>
		}

		@if (isLoading) {
			<app-typing-indicator></app-typing-indicator>
		}
	</div>

	@if (showScrollButton) {
		<button class="scroll-to-bottom" (click)="scrollToBottom()" aria-label="Scroll to bottom" data-testid="message-list-btn-scroll-bottom">
			<mat-icon>keyboard_arrow_down</mat-icon>
		</button>
	}
</div>
